import { Grid } from '@mui/material';
import { styles } from '~/modules/identification/forms/BusinessRelations/styles.ts';
import TableCell from '~/components/ListCardTable/TableCell.tsx';
import { FormInput } from '~/components/FormComponents/FormInput.tsx';
import { TableActionButtons } from '~/components/ListCardTable/TableActionButtons.tsx';
import { EMPTY_INFO_CONTACTS } from '~/modules/identification/forms/BusinessRelations/constants.ts';
import { TInfoContacts } from '~/modules/identification/forms/BusinessRelations/types.ts';
import { FormPhoneField } from '~/components/FormComponents/FormPhoneField.tsx';

interface IInfoContactsTableProps {
  name: string;
  index: number;
  showRemove: boolean;
  shownAppend?: boolean;
  append: (item: TInfoContacts) => void;
  remove: (index: number) => void;
}

export const InfoContactsTable = ({
  index,
  name,
  showRemove,
  shownAppend,
  append,
  remove,
}: IInfoContactsTableProps) => {
  return (
    <Grid container sx={styles.row}>
      <TableCell title="Ім'я та прізвище" size={4}>
        <FormInput
          name={`${name}.${index}.name`}
          placeholder={'Введіть повне прізвище, ім’я по батькові'}
          variant="standard"
          fullWidth
          sx={{
            ...styles.tableInput,
            pt: '14px',
          }}
          inputProps={{
            maxLength: 120,
          }}
        />
      </TableCell>
      <TableCell title="Номер контактного телефону" size={4}>
        <FormPhoneField name={`${name}.${index}.phone`} variant="standard" sx={{ pt: '14px' }} />
      </TableCell>
      <TableCell title="Адреса електронної пошти" size={3}>
        <FormInput
          name={`${name}.${index}.email`}
          fullWidth
          placeholder="Введіть адресу електронної пошти"
          variant="standard"
          sx={{
            ...styles.tableInput,
            pt: '14px',
          }}
          inputProps={{
            maxLength: 70,
          }}
        />
      </TableCell>
      <TableActionButtons
        addClick={() => append(EMPTY_INFO_CONTACTS)}
        removeClick={() => remove(index)}
        showRemove={showRemove}
        shownAppend={shownAppend}
      />
    </Grid>
  );
};
